module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-192x192-2061b82e944de1836d444acfe75ebc1a.png";